import { useAppStore } from '../../state/store';
import { WorksetsDialog } from './WorksetsDialog';
import { CollaborateDialog } from './CollaborateDialog';
import { SynchronizeDialog } from './SynchronizeDialog';
import { RelinquishDialog } from './RelinquishDialog';
import { PublishSettingsDialog } from './PublishSettingsDialog';
import { CloudModelsDialog } from './CloudModelsDialog';
import { CopyMonitorDialog } from './CopyMonitorDialog';
import { CoordinationReviewDialog } from './CoordinationReviewDialog';
import { InterferenceCheckDialog } from './InterferenceCheckDialog';

/**
 * Central mount point for all Collaborate tab dialogs. Rendered once in the
 * global layout; visibility is driven by appStore.collabDialog.
 */
export function CollabDialogsHost() {
    const collabDialog = useAppStore((state) => state.collabDialog);

    if (!collabDialog) return null;

    switch (collabDialog) {
        case 'worksets':
            return <WorksetsDialog />;
        case 'collaborate':
            return <CollaborateDialog />;
        case 'synchronize':
            return <SynchronizeDialog />;
        case 'relinquish':
            return <RelinquishDialog />;
        case 'publishSettings':
            return <PublishSettingsDialog />;
        case 'cloudModels':
            return <CloudModelsDialog />;
        case 'copyMonitor':
            return <CopyMonitorDialog />;
        case 'coordinationReview':
            return <CoordinationReviewDialog />;
        case 'interference':
            return <InterferenceCheckDialog />;
        default:
            return null;
    }
}

export { WorksetsDialog } from './WorksetsDialog';
